import React, { useEffect, useRef, useState } from "react";
import { Bold, Italic, Heading2, Heading3, List, ListOrdered, Link2, ImagePlus } from "lucide-react";
import { mediaUrl } from "../../../lib/cms";
import MediaPicker from "./MediaPicker";

const TOOLS = [
  { icon: Heading2, cmd: "formatBlock", arg: "h2", tid: "h2" },
  { icon: Heading3, cmd: "formatBlock", arg: "h3", tid: "h3" },
  { icon: Bold, cmd: "bold", tid: "bold" },
  { icon: Italic, cmd: "italic", tid: "italic" },
  { icon: List, cmd: "insertUnorderedList", tid: "ul" },
  { icon: ListOrdered, cmd: "insertOrderedList", tid: "ol" },
];

export default function RichText({ value, onChange, readOnly }) {
  const ref = useRef();
  const [picker, setPicker] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el && el.innerHTML !== (value || "") && document.activeElement !== el) el.innerHTML = value || "";
  }, [value]);

  const run = (cmd, arg) => {
    ref.current.focus();
    document.execCommand(cmd, false, arg);
    onChange(ref.current.innerHTML);
  };
  const link = () => {
    const url = window.prompt("Link URL");
    if (url) run("createLink", url);
  };

  return (
    <div className="overflow-hidden rounded-xl border border-sapphire-deep/20 bg-white focus-within:border-gold focus-within:ring-2 focus-within:ring-gold/30">
      {!readOnly && (
        <div className="flex flex-wrap gap-1 border-b border-sapphire-deep/10 bg-parchment/60 p-2">
          {TOOLS.map((t) => (
            <button key={t.tid} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => run(t.cmd, t.arg)}
              className="rounded-lg p-2 text-sapphire-deep transition-colors hover:bg-gold/20" data-testid={`rte-${t.tid}`}>
              <t.icon size={16} />
            </button>
          ))}
          <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={link} className="rounded-lg p-2 text-sapphire-deep hover:bg-gold/20" data-testid="rte-link">
            <Link2 size={16} />
          </button>
          <button type="button" onClick={() => setPicker(true)} className="rounded-lg p-2 text-sapphire-deep hover:bg-gold/20" data-testid="rte-image">
            <ImagePlus size={16} />
          </button>
        </div>
      )}
      <div
        ref={ref}
        contentEditable={!readOnly}
        suppressContentEditableWarning
        onInput={() => onChange(ref.current.innerHTML)}
        className="prose-article min-h-[220px] px-5 py-4 font-sans text-[15px] outline-none"
        data-testid="rte-body"
      />
      {picker && (
        <MediaPicker
          kind="image"
          onClose={() => setPicker(false)}
          onPick={(p) => {
            setPicker(false);
            if (p.media) run("insertHTML", `<img src="${mediaUrl(p.media.id)}" alt="${p.name}" />`);
          }}
        />
      )}
    </div>
  );
}
